import React, { forwardRef } from 'react'
import { useTheme } from '@mui/material/styles'
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material'

import styled from '@emotion/styled'

const StyledCardHeader = styled(CardHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .MuiCardHeader-content {
    flex: none;
    margin: 0;
  }
  .MuiCardHeader-action {
    flex: none;
    margin: 0;
  }
`

const StyledCardContent = styled(CardContent)`
  &.MuiCardContent-root:last-child {
    padding-bottom: 0;
  }
`

interface Props {
  border?: boolean
  boxShadow?: boolean
  children?: React.ReactNode
  content?: boolean
  contentClass?: string
  contentSX?: object
  darkTitle?: boolean
  secondary?: string | React.ReactNode | boolean
  shadow?: string
  sx?: object
  title?: string
}

const MainCard = forwardRef<HTMLDivElement, Props>(
  (
    {
      border = true,
      boxShadow,
      children,
      content = true,
      contentClass = '',
      contentSX = {},
      darkTitle,
      secondary,
      shadow,
      sx = {},
      title,
      ...others
    }: Props,
    ref
  ) => {
    const theme = useTheme()

    return (
      <Card
        ref={ref}
        {...others}
        sx={{
          borderRadius: 2.5,
          borderColor: theme.palette.grey[200],
          ...sx,
        }}
      >
        {/* card header and action */}
        {title && (
          <StyledCardHeader
            style={{}}
            title={
              darkTitle ? (
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  {title}
                </Typography>
              ) : (
                title
              )
            }
            action={secondary}
          />
        )}

        {/* content & header divider */}
        {title && <Divider />}

        {/* card content */}
        {content && (
          <StyledCardContent sx={contentSX} className={contentClass}>
            {children}
          </StyledCardContent>
        )}
        {!content && children}
      </Card>
    )
  }
)

export default MainCard
